/* eslint-disable no-template-curly-in-string */
/**
 * Unlocked or In progress survey card.
 */

import {
  Flex,
  Heading,
  HStack,
  Link as ChakraLink,
  Text,
  VStack,
  Tooltip,
} from "@chakra-ui/react";
import useAuth from "hooks/useAuth";
import useOpenVerificationModal from "hooks/useOpenVerificationModal";
import { Link } from "react-router-dom";
import {
  ClockIcon,
  InfoIcon,
  SurveyUnlockedIcon,
} from "../../base/atoms/HJSIcons";

type TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => JSX.Element;

const UnlockedSurveyCard: TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => {
  const { userDetails } = useAuth();
  const shouldOpenVerificationModal = useOpenVerificationModal();
  const tooltipLabel1 =
    surveyIdentifier === "personality"
      ? "Complete this survey to earn money! We'll mail a check as soon as you finish."
      : `We send a text message survey every 1-2 weeks while you wait for surveys to unlock. You earned $${
          survey?.earnedSmsAmount as string
        } for responding to $${survey?.completeSms as string} out of ${
          survey?.totalSms as string
        } text message surveys. We'll mail a check for the completed text surveys along with your money for completing this follow up.`;

  const tooltipLabel =
    surveyIdentifier === "personality"
      ? "You will earn $20 dollars when you complete this survey. We'll mail a check with your earnings to your registered address."
      : surveyIdentifier === "followUp1"
      ? "You will earn $25 dollars when you complete this survey. We'll mail a check with your earnings to your registered address."
      : "You will earn $35 dollars when you complete this survey. We'll mail a check with your earnings to your registered address.";
  return (
    <ChakraLink
      w="full"
      as={Link}
      to={`/survey/${surveyIdentifier}`}
      // className={`${
      //   (userDetails?.isEligible as boolean) ? "" : "disable-link"
      // }`}
      _hover={{ textDecor: "none", shadow: "lg" }}
      onClick={(e) => {
        !(userDetails?.isEligible as boolean) && e.preventDefault();
        shouldOpenVerificationModal();
      }}
      mt={12}
    >
      <Flex flexDir="column" overflow="hidden">
        <Flex
          px={[4, 6, 10]}
          py={[4, 5, 6]}
          borderTopLeftRadius="8px"
          borderTopRightRadius="8px"
          bgColor="teal.600"
          justifyContent="space-between"
        >
          <Heading
            as="h2"
            textTransform="uppercase"
            fontSize={[16, 16, 20, "1.5rem"]}
            color="white"
          >
            {survey.title}
          </Heading>
          <HStack fontSize={[10, 10, 12]}>
            <SurveyUnlockedIcon
              boxSize={6}
              fill="none"
              height={["14px", 6, 9]}
              width={[3, 6, 8]}
            />
            <Text color="white" fontWeight="700">
              {`${survey.surveyState as string}`}
            </Text>
          </HStack>
        </Flex>
        <VStack
          flexGrow={1}
          w="full"
          justifyContent="space-between"
          alignItems="flex-start"
          backgroundColor="teal.50"
          borderBottomLeftRadius="8px"
          borderBottomRightRadius="8px"
          py={[5, 6, 7, 10]}
          px={[4, 6, 10]}
          pr="initial !important"
        >
          <Text color="hjsBlack" fontSize="0.75rem" fontWeight="500">
            {survey.description}
          </Text>
          <Flex w="full" justifyContent="space-between" alignItems="center">
            <HStack>
              <ClockIcon
                fill="none"
                boxSize={6}
                color="teal.900"
                height={[4, 4, 5]}
                width={[4, 4, 5]}
              />
              <Text color="teal.900" fontSize={[12, 12, 16]} fontWeight="700">
                Estimated Duration: {survey.estimatedTime}
              </Text>
            </HStack>
            <Flex
              bgColor="teal.600"
              justifyContent="space-around"
              alignItems="center"
              py={2.5}
              borderRadius="4px"
              pr={[2, 3, 4]}
            >
              <Text
                color="white"
                fontWeight="700"
                fontSize={[16, 16, 20]}
                px={[3, 5, 7]}
              >
                $
                {`${survey.earnedCompensation as string} / $${
                  survey.maxSurveyCompensation as string
                }`}
              </Text>
              <Tooltip
                label={
                  userDetails?.layer === 2 || userDetails === null
                    ? tooltipLabel
                    : tooltipLabel1
                }
                placement="top-start"
              >
                <InfoIcon
                  boxSize={6}
                  fill="none"
                  height={[4, 5, 6]}
                  width={[4, 5, 6]}
                />
              </Tooltip>
            </Flex>
          </Flex>
        </VStack>
      </Flex>
    </ChakraLink>
  );
};

export default UnlockedSurveyCard;
